<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '@/lib/utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
  testId?: string;
  rowId?: string | number;
}>();
</script>

<template>
  <tr :data-testid="props.testId" :class="cn('border-b', props.class)" :data-rowid="rowId">
    <slot />
  </tr>
</template>
